<template>
  <div class="popup">
    <div class="popup_cover"></div>
    <div class="file-upload-popup">
      <div class="popup-header">
        <div class="popup_title">{{ props.수주수행구분 }} 담당자 연락처</div>
        <img src="@/assets/images/close_btn.png" @click="closePopup(false)" class="close_icon" />
      </div>
      <div class="popup-body">
        <div class="contact_header">
          <div class="contact_header_column">성함</div>
          <div class="contact_header_column">연락처</div>
          <div class="contact_header_column">직통번호</div>
          <div class="contact_header_column">이메일</div>
          <div class="contact_header_column">비고</div>
        </div>
        <div class="contact_body">
          <div class="contact_div" v-for="(item, index) in ['1', '2', '3']" :key="index">
            <input class="contact_inp" type="text" v-model="announceData[`${props.수주수행구분}담당자이름${item}`]" />
            <input class="contact_inp" type="text" v-model="announceData[`${props.수주수행구분}담당자전화번호${item}`]"/>
            <input class="contact_inp" type="text" v-model="announceData[`${props.수주수행구분}담당자직통번호${item}`]"/>
            <input class="contact_inp" type="text" v-model="announceData[`${props.수주수행구분}담당자이메일${item}`]"/>
            <input class="contact_inp" type="text" v-model="announceData[`${props.수주수행구분}담당자비고${item}`]"/>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <div class="popup_close_btn" @click="closePopup(false)">취소</div>
        <div class="popup_confirm_btn" @click="modify()">저장</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, defineEmits, defineProps, onMounted } from "vue";
import anncounceAPI from "@/api/announceAPI";
import { Announce, AnnounceContact } from "@/common/types";
import { phoneNumberFormat } from "@/utils/utils";

const announceData = ref({} as Announce & Record<string, any>);
onMounted(() => {
  announceData.value = JSON.parse(JSON.stringify(props.announceData));
});

const props = defineProps<{
  announceData: Announce;
  수주수행구분: string | null;
}>();

const emit = defineEmits(["closePopup"]);
const modify = () => {
  // 공고순번 추출
  const 공고순번 = announceData.value.공고순번;

  if (!공고순번) {
    alert("공고순번 값이 없습니다.");
    return;
  }
  // 데이터 객체 생성
  let data: Partial<AnnounceContact> = {};
  // 수주 또는 수행에 따른 데이터 설정
  if (props.수주수행구분 === "수주") {
    data.수주담당자이름1 = announceData.value.수주담당자이름1;
    data.수주담당자이름2 = announceData.value.수주담당자이름2;
    data.수주담당자이름3 = announceData.value.수주담당자이름3;
    data.수주담당자전화번호1 = announceData.value.수주담당자전화번호1 ? announceData.value.수주담당자전화번호1.replaceAll("-", "") : "";
    data.수주담당자전화번호2 = announceData.value.수주담당자전화번호2 ? announceData.value.수주담당자전화번호2.replaceAll("-", "") : "";
    data.수주담당자전화번호3 = announceData.value.수주담당자전화번호3 ? announceData.value.수주담당자전화번호3.replaceAll("-", "") : "";
    data.수주담당자직통번호1 = announceData.value.수주담당자직통번호1 ? announceData.value.수주담당자직통번호1.replaceAll("-", "") : "";
    data.수주담당자직통번호2 = announceData.value.수주담당자직통번호2 ? announceData.value.수주담당자직통번호2.replaceAll("-", "") : "";
    data.수주담당자직통번호3 = announceData.value.수주담당자직통번호3 ? announceData.value.수주담당자직통번호3.replaceAll("-", "") : "";
    data.수주담당자이메일1 = announceData.value.수주담당자이메일1;
    data.수주담당자이메일2 = announceData.value.수주담당자이메일2;
    data.수주담당자이메일3 = announceData.value.수주담당자이메일3;
    data.수주담당자비고1 = announceData.value.수주담당자비고1;
    data.수주담당자비고2 = announceData.value.수주담당자비고2;
    data.수주담당자비고3 = announceData.value.수주담당자비고3;
  } else if (props.수주수행구분 === "수행") {
    data.수행담당자이름1 = announceData.value.수행담당자이름1;
    data.수행담당자이름2 = announceData.value.수행담당자이름2;
    data.수행담당자이름3 = announceData.value.수행담당자이름3;
    data.수행담당자전화번호1 = announceData.value.수행담당자전화번호1 ? announceData.value.수행담당자전화번호1.replaceAll("-", "") : "";
    data.수행담당자전화번호2 = announceData.value.수행담당자전화번호2 ? announceData.value.수행담당자전화번호2.replaceAll("-", "") : "";
    data.수행담당자전화번호3 = announceData.value.수행담당자전화번호3 ? announceData.value.수행담당자전화번호3.replaceAll("-", "") : "";
    data.수행담당자직통번호1 = announceData.value.수행담당자직통번호1 ? announceData.value.수행담당자직통번호1.replaceAll("-", "") : "";
    data.수행담당자직통번호2 = announceData.value.수행담당자직통번호2 ? announceData.value.수행담당자직통번호2.replaceAll("-", "") : "";
    data.수행담당자직통번호3 = announceData.value.수행담당자직통번호3 ? announceData.value.수행담당자직통번호3.replaceAll("-", "") : "";
    data.수행담당자이메일1 = announceData.value.수행담당자이메일1;
    data.수행담당자이메일2 = announceData.value.수행담당자이메일2;
    data.수행담당자이메일3 = announceData.value.수행담당자이메일3;
    data.수행담당자비고1 = announceData.value.수행담당자비고1;
    data.수행담당자비고2 = announceData.value.수행담당자비고2;
    data.수행담당자비고3 = announceData.value.수행담당자비고3;
  }

  // API 호출
  anncounceAPI.modifyContact(data, 공고순번).then((res) => {
    if (res.data.success) {
      alert("등록이 완료되었습니다.");
      closePopup(true); // 팝업 닫기
    }
  });
};

const closePopup = (refresh: boolean) => {
  emit("closePopup", { popupType: "contact", refresh });
};
</script>

<style scoped>
.popup {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
}
.popup_cover {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
}
.file-upload-popup {
  /* Add your styles here */
  left: 50%;
  position: fixed;
  background-color: white;
  width: 1220px;
  height: 380px;
  background: white;
  top: calc(50% - 190px);
  left: calc(50% - 610px);
  border-radius: 11px;
}
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 71px;
  padding: 22px 27px 22px 40px;
  border-bottom: 1px solid #dbdbdb;
}
.popup_title {
  font-size: 20px;
  font-family: "Noto Sans CJK KR-Bold";
  letter-spacing: -0.05em;
  color: black;
}
.popup-body {
  /* margin-top: 10px; */
  padding: 20px 40px;
  height: 230px;
}
.popup_desc {
  font-family: "Noto Sans CJK KR-Medium";
  font-size: 14px;
  line-height: 20px;
  color: black;
  margin-bottom: 15px;
}
.file_title {
  border: 1px solid #d0d0d0;
  height: 39px;
  width: 100%;
  border-radius: 4px;
  padding-left: 12px;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Medium";
  margin-bottom: 15px;
}
.file_upload_area {
  height: 145px;
  border: 1px solid #dbdbdb;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #838383;
  gap: 10px;
  border-radius: 4px;
  cursor: pointer;
}
.file_upload_area.upload {
  cursor: default;
}
.popup-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0px 40px;
  gap: 10px;
}
.file_inp {
  width: 0px;
  height: 0px;
}
.popup_close_btn {
  width: 132px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ededed;
  border-radius: 6px;
  font-family: "Noto Sans CJK KR-Bold";
  color: #383838;
  font-size: 14px;
  cursor: pointer;
}
.popup_confirm_btn {
  width: 132px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #3382e9;
  border-radius: 6px;
  font-family: "Noto Sans CJK KR-Bold";
  color: white;
  font-size: 14px;
  cursor: pointer;
}
.close_icon {
  cursor: pointer;
}

.contact_header {
  display: flex;
  margin-bottom: 11px;
  height: 19px;
}
.contact_body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.contact_div {
  display: flex;
  gap: 17px;
}

.contact_name_inp,
.contact_phone_inp {
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  height: 39px;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Medium";
  color: black;
  padding-left: 12px;
}
.contact_inp {
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  height: 39px;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Medium";
  color: black;
  padding-left: 12px;
  width: calc(100% / 5);
}
.contact_header_column {
  border-radius: 4px;
  height: 39px;
  font-family: "Noto Sans CJK KR-Medium";
  padding-left: 12px;
  width: calc(100% / 5);
  color: #b9b9b9;
  font-size: 14px;
}

.contact_name_inp {
  width: 124px;
}
.contact_phone_inp {
  width: 231px;
}
</style>
